@if (grouped) {
  <div class="input-group mb-2">
    @if (label) {
      <div class="input-group-prepend" [ngClass]="styleClass">
        <span class="input-group-text">{{ label | translate }}</span>
      </div>
    }
    <ng-container *ngTemplateOutlet="grouped? content : null"></ng-container>
    <ng-content></ng-content>
  </div>
}

@if (!grouped) {
  @if (label) {
    <label>
      {{ label | translate }}
    </label>
  }
  <ng-container *ngTemplateOutlet="!grouped? content : null"></ng-container>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>